import { isTeamVisibilityModeHidden } from '../utils/user'

import { useInitData } from './useInitData'

export function useIsTeamVisibilityHidden() {
  const initData = useInitData()

  return isTeamVisibilityModeHidden(initData?.uk?.config?.team_visibility_mode)
}
